import { ScopeOfPracticeEnum, ShiftStatusEnum } from '@umss/shared/utils';

export interface ContractorReviewSummaryDto {
  scopeOfPractice?: ScopeOfPracticeEnum;

  canReview?: boolean;

  hasReview?: boolean;

  /**
   * format: double
   */
  score?: number;

  /**
   * format: int32
   */
  count?: number;

  lastShift?: ContractorReviewLastShiftDto;
}

export interface ContractorReviewLastShiftDto {
  /**
   * format: uuid
   */
  id?: string;

  /**
   * format: date
   */
  shiftDate?: string;

  /**
   * format: time
   */
  startTime?: string;

  /**
   * format: time
   */
  endTime?: string;

  status?: ShiftStatusEnum;

  scopeOfPractice?: ScopeOfPracticeEnum;
}

export interface ContractorReviewDetailDto {
  scopeOfPractice?: ScopeOfPracticeEnum;

  /**
   * format: int32
   */
  score?: number;

  comment?: string;

  /**
   * format: date-time
   */
  createdAt?: string;

  /**
   * format: date-time
   */
  updatedAt?: string;
}
